import React from "react";
import { Box, Typography } from "@mui/material";

interface EmptyStateProps {
  message: string;
  variant?: "body1" | "body2";
}

export default function EmptyState({ message, variant = "body1" }: EmptyStateProps) {
  return (
    <Box sx={{ py: 4, textAlign: "center" }}>
      <Typography variant={variant} color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
}
